<template>
    <div class="p-3">     

        <form-modal
            id="cronograma"
            placeholder-button="Inserir etapa não prevista" 
            :fields="cols"
            :values="rows"
            
            @ok="salvar"
            @cancel="inicializarForm"
            @remove="remover"
            @rowClick="editar"

            ref="modal"
            :title-modal="tituloModal"
            is-gantt
            is-gantt-multiple
            
            :remove-enabled="form.id && !form.previsto && permissao.d"
            :ok-disabled="form.id && !form.previsto && !permissao.u"
            :create="controlesLiberados && permissao.c"
            :read="controlesLiberados && permissao.r"
            :update="controlesLiberados && permissao.u"
            :remove="controlesLiberados && permissao.d"   

            :controles="controlesLiberados"         
        >
            <template #modal>
                <modal :projeto-editavel="projetoEditavel" :duracao="projeto.duracao" @update="buscar" :data-inicio="projeto.dataInicio" :form="form" ref="form" :numero-etapa="(dados ? ( dados.length == 0 ? 1 : parseInt(dados[dados.length - 1].etapa.numero) + 1 ) : 1)"  />
            </template>
        </form-modal>

        <hr class="row">
        <div class="row">
            <div class="col-12 col-md-2" style="display:flex;font-size: 12px;">
                <div class="bg-gradient-info round mr-2"></div>
                <span>Previsto</span>
            </div>
            <div class="col-12 col-md-2" style="display:flex;font-size: 12px;">
                <div class="bg-gradient-primary round mr-2"></div>
                <span>Etapa não prevista</span>
            </div>
            <div class="col-12 col-md-2" style="display:flex;font-size: 12px;">
                <div class="bg-gradient-success round mr-2"></div>
                <span>Concluído no prazo</span>
            </div>
            <div class="col-12 col-md-3" style="display:flex;font-size: 12px;">
                <div class="bg-gradient-warning round mr-2"></div>
                <span>Concluído em atraso</span>
            </div>
            <div class="col-12 col-md-3" style="display:flex;font-size: 12px;">
                <div class="bg-gradient-danger round mr-2"></div>
                <span>Concluída antecipadamente</span>
            </div>
        </div>
    </div>
</template>
<script>
import ProjetoService from "@/common/services/projeto/projeto.service";
import {AlertasMixin} from "@/common/mixins/AlertasMixin";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import FormModal from "@/components/modal/FormModal";
import cloneDeep from "lodash/cloneDeep";
import helpers from "@/common/utils/helpers";

import modal from "./modal.vue";


export default {
    mixins: [AlertasMixin],
    components: {
        FormModal,
        modal
    },
    props : {
        projetoId : {
            type : String,
            required : true
        },
        projetoIdBase : {
            type : String,
            required : true
        },
        projeto : {
            type : Object,
            required : true
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
    },
    data : () => ({
        dados : [],
        form : {},
        tituloModal : "",
    }),
    methods : {
        salvar : function(){
            //Cria um cronograma não previsto o registro é feito por completo
            this.confirmar('Aviso','Deseja criar um cronograma não previsto?').then((result) =>{
                if (result) {

                    if(this.$refs.form.validateState() == false) return;

                    this.$store.dispatch(START_LOADING);

                    let form = cloneDeep(this.form);
                    form.projetoId = this.projetoIdBase;
                    form.detalhamentoProjeto = form.detalhamento;


                    ProjetoService.salvarGenerico('cronograma-etapa',form).then(() => {

                        this.alertaSucesso('Cronograma salvo com sucesso!').then(() => {
                            this.inicializarForm();
                            this.buscar();
                            this.$refs.modal.closeModal();
                        });
                        
                    }).catch(err => {
                        if(err.response.status == 400){
                            this.alertaErro(`${err.response.data.errors}`)
                        }else{
                            this.alertaErro('Ocorreu um erro ao salvar o cronograma!')
                        }
                    }).finally(() => {
                        this.$store.dispatch(STOP_LOADING);
                    });

                } 
            });
        },


        editar : function(row){
            this.form = (row.form);
            this.form.relatoriosEtapas.map(el => {
                el.mostrarArquivos = false;
                el.dataEmissao = helpers.formatarDataBr(el.dataEmissao);
                return el;
            })
            this.tituloModal = row.form.etapa.tituloDaEtapa;
            this.$refs.modal.openModal();
        },
        remover : function(){
            let id = this.form.id;
            this.confirmar('Aviso','Deseja excluir o cronograma?').then((result) =>{
                if (result) {
                    this.$store.dispatch(START_LOADING);
                    ProjetoService.excluirCronograma(id).then(() => {

                        this.alertaSucesso('Cronograma excluído com sucesso!').then(() => {
                            this.inicializarForm();
                            this.buscar();
                            this.$refs.modal.closeModal();
                        });
                        
                    }).catch(err => {
                        if(err.response.status == 400){
                            this.alertaErro(`${err.response.data.errors}`)
                        }else{
                            this.alertaErro('Ocorreu um erro ao excluir o cronograma!')
                        }
                    }).finally(() => {
                        this.$store.dispatch(STOP_LOADING);
                    });
                }
            });            
        },

        inicializarForm : function(){
            this.tituloModal = "CRONOGRAMA DE ETAPAS";
            this.form = {
                etapa: {
                    numero: null,
                    tituloDaEtapa: null,
                    mesInicial: 0,
                    mesFinal: 0,
                    mesInicialRealizado: 0,
                    mesFinalRealizado: 0,
                    prevista: false
                },
                subetapas: [],
                relatoriosEtapas: [],
                detalhamento: null,
                previsto: false
            }
        },

        buscar : function(){
            this.$store.dispatch(START_LOADING);
            ProjetoService.listarCronograma(this.projetoIdBase).then(response => {
                this.dados = response.data.data.sort((a,b) => a.etapa.numero - b.etapa.numero);       
            }).catch(() => {
                this.alertaErro("Erro ao buscar");
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
        montar(){
            this.buscar();
            this.inicializarForm();
        }
    },
    mounted : function(){
        this.buscar();
        this.inicializarForm();
    },
    computed: {
        permissao() {
            return this.$store.getters['app/retornaPermissao']('ProjetosPdCronogramaEtapa');
        },
        cols : function(){
            let columns = [];
            let ano = helpers.formatarData(this.projeto.dataInicio, 'YYYY');
            let mes = helpers.formatarData(this.projeto.dataInicio, 'MM');
            let dia = helpers.formatarData(this.projeto.dataInicio, 'DD');

            for (let index = 0; index <= this.projeto.duracao; index++) {
                columns.push({
                    key: index+1,
                    title: `${dia}/${helpers.retornarNomeMes(mes)}/${ano}`,
                });
                
                mes++;
                if(mes > 12){
                    mes = 1;
                    ano++;
                }
            }


            return columns;
        },
        rows: function(){
            let rows = [];

            if(this.dados)

            rows = this.dados.map(el => {
                
                let elemento = [];

                elemento.push(
                    {
                        key: `${el.id}-1`,
                        width: el.etapa.prevista ? el.etapa.mesFinal - (el.etapa.mesInicial - 1) : el.etapa.mesFinalRealizado - (el.etapa.mesInicialRealizado - 1),
                        left: el.etapa.prevista ? el.etapa.mesInicial - 1 : el.etapa.mesInicialRealizado - 1,
                        title: el.etapa.tituloDaEtapa,
                        number : el.etapa.numero,
                        form: el,
                        variant: el.etapa.prevista ? 'info' : 'primary',
                        buttonAdd : this.controlesLiberados && (el.etapa.mesInicialRealizado == 0 || el.etapa.mesFinalRealizado == 0),
                        desabilitarClick : el.etapa.prevista,
                    }
                );

                if(el.etapa.prevista){
                    elemento.push(
                        {
                            key: `${el.id}-2`,
                            width: el.etapa.mesFinalRealizado - (el.etapa.mesInicialRealizado - 1),
                            left: el.etapa.mesInicialRealizado - 1,
                            title: el.etapa.tituloDaEtapa,
                            number : el.etapa.numero,
                            form: el,
                            variant: el.etapa.mesFinalRealizado <= el.etapa.mesFinal ? 
                                        el.etapa.mesFinalRealizado < el.etapa.mesFinal ? 
                                       'danger' : 'success' 
                                    : 'warning',
                            buttonAdd : false
                        },
                    );
                }

                return elemento;
            })

            return rows;
        },
        controlesLiberados :function(){
            return this.$route.name == 'projeto-detalhamento-executora-criadora' && this.projetoEditavel
        },
    }

    
}
</script>
<style>
    .round {
        width: 20px;
        height: 20px;
        border-radius: 10px;
    }
</style>